/**
 *  @class
 *  @function CartRecommendedProduct
 */
if (!customElements.get('cart-recommended-product')) {
  class CartRecommendedProduct extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-cart-item-image img');
      this.add = this.querySelector('.cart-item-add');
      this.price = this.querySelector('.price');
      this.selector = this.querySelector('.product-recommendation-select');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.selector) {
        this.enableSelector();
      }
    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = this.image ? this.image.dataset.srcset : '';

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', () => {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (this.image) {
            if (swatch.dataset.srcset) {
              this.image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              this.image.setAttribute('srcset', org_srcset);
            }
          }
          if (this.add && swatch.dataset.variant) {
            this.add.dataset.variant = swatch.dataset.variant;
            const url = new URL(this.add.href, window.location.origin);
            url.searchParams.set('id', swatch.dataset.variant);
            this.add.href = url.toString();
          }
          if (this.price && (swatch.dataset.price || swatch.dataset.rrp)) {
            const swatch_price = swatch.dataset.price ? swatch.dataset.price / 100 : null;
            const swatch_rrp = swatch.dataset.rrp ? swatch.dataset.rrp / 100 : null;

            if (swatch_price && swatch_rrp && swatch_rrp > swatch_price) {
              this.price.innerHTML = `
                <del><span class="amount">$${swatch_rrp.toFixed(2)}</span></del>
                <ins><span class="amount discounted">$${swatch_price.toFixed(2)}</span></ins>
              `
            } else {
              this.price.innerHTML = `
                <ins><span class="amount discounted">$${swatch_price.toFixed(2)}</span></ins>
              `
            }
          }

          swatch.classList.add('active');
        });
      });
    }
    enableSelector() {
      let org_srcset = this.image ? this.image.dataset.srcset : '';

      window.addEventListener('load', () => {
        const loadedImages = new Set();

        [...this.selector.options].forEach(option => {
          const srcset = option.dataset.srcset;

          if (srcset && !loadedImages.has(srcset)) {
            loadedImages.add(srcset);

            const image = new Image();
            image.srcset = srcset;
            lazySizes.loader.unveil(image);
          }
        });
      });

      this.selector.addEventListener('change', (event) => {
        const selectedOption = event.target.selectedOptions[0];
        
        if (!selectedOption) return;

        if (this.image) {
            if (selectedOption.dataset.srcset) {
              this.image.setAttribute('srcset', selectedOption.dataset.srcset);
            } else {
              this.image.setAttribute('srcset', org_srcset);
            }
          }
          if (this.add && selectedOption.value) {
            this.add.dataset.variant = selectedOption.value;
            const url = new URL(this.add.href, window.location.origin);
            url.searchParams.set('id', selectedOption.value);
            this.add.href = url.toString();
          }
          if (this.price && (selectedOption.dataset.price || selectedOption.dataset.rrp)) {
            const option_price = selectedOption.dataset.price ? selectedOption.dataset.price / 100 : null;
            const option_rrp = selectedOption.dataset.rrp ? selectedOption.dataset.rrp / 100 : null;

            if (option_price && option_rrp && option_rrp > option_price) {
              this.price.innerHTML = `
                <del><span class="amount">$${option_rrp.toFixed(2)}</span></del>
                <ins><span class="amount discounted">$${option_price.toFixed(2)}</span></ins>
              `
            } else {
              this.price.innerHTML = `
                <ins><span class="amount discounted">$${option_price.toFixed(2)}</span></ins>
              `
            }
          }
      })
    }
  }
  customElements.define('cart-recommended-product', CartRecommendedProduct);
}